(function () {
  var AcceptFlow,
    Environment,
    FeatureFlag,
    PubSub,
    addProjectTotals,
    addQuoteDetails,
    paragraph,
    ref,
    scrollToTop,
    text,
    tokenRenderer;

  addProjectTotals = require("./AddProjectTotals.ts")["default"];

  FeatureFlag = require("@CommonFrontendBackend/FeatureFlag").FeatureFlag;

  Environment = require("@CommonFrontendBackend/Environment").Environment;

  tokenRenderer = require("ContentTokens/TokenRenderer.ts")["default"];

  (ref = require("ContentTokens/TokenModels")["default"]), (paragraph = ref.paragraph), (text = ref.text);

  addQuoteDetails = require("./Utils/AddQuoteDetails")["default"];

  scrollToTop = require("./Utils/ScrollToTop").scrollToTop;

  PubSub = require("@qwilr/pages-common").PubSub;

  /*
    @param accepters [Object[]]
  
    @param onPostAcceptance Called upon finishing acceptance and clicking the "continue" button.
  
    The acceptFlow should also be given default behaviour for `closeCurrent` and `closeAll` injected
    functions. These may be overridden in specific circumstances (namely, `closeCurrent` when a group
    accept moves to single accept).
   */

  module.exports = AcceptFlow = (function () {
    function AcceptFlow(
      createUi,
      di,
      make,
      accepters,
      settings,
      sendAcceptRequest,
      secretHash,
      $q,
      projectTotal,
      isTotalVisible,
      isStripeIntegrationEnabled,
      onPostAcceptance,
      onShowExperienceSurvey,
      getAuditTrailPdfUrl,
      usingFeature,
      closeCurrent,
      closeAll,
      $timeout,
      acceptTelemetry,
      environment,
      isPreviewMode,
      isPrintMode,
    ) {
      var acceptData,
        acceptForm,
        acceptModule,
        acceptUtils,
        attemptAccept,
        changeViewState,
        disclaimer,
        getUnbuiltSteps,
        hasNoPrefillSignature,
        ref1,
        acceptData = {
          linkSecret: secretHash,
          isTotalVisible: isTotalVisible,
          auditTrailPdfUrl: "",
        };
      isUsingInlineForm = !usingFeature(FeatureFlag.OptOutNewEditor);
      hasNoPrefillSignature = void 0;
      PubSub.subscribe(
        "qwilr:prefill-not-found",
        (function (_this) {
          return function (arg) {
            var hasSavedPrefillData, user;
            (user = arg.user), (hasSavedPrefillData = arg.hasSavedPrefillData);
            return (hasNoPrefillSignature = user && !hasSavedPrefillData);
          };
        })(this),
      );
      if (di.has("visitToken")) {
        acceptData.visitToken = di.get("visitToken");
      }
      acceptUtils = make(require("AcceptFlow/Utils/Utils"));
      di.value("acceptUtils", acceptUtils);
      changeViewState = (function (_this) {
        return function (viewState) {
          return $timeout(function () {
            if (viewState !== _this.ui.viewState) {
              _this.ui.viewState = viewState;
              return scrollToTop();
            }
          });
        };
      })(this);
      attemptAccept = (function (_this) {
        return function (acceptData, event) {
          if (!isUsingInlineForm) {
            changeViewState("sending");
          }
          addProjectTotals(acceptData, projectTotal);
          return sendAcceptRequest(acceptData)
            .then(function () {
              return getAuditTrailPdfUrl();
            })
            .then(function (url) {
              acceptData.auditTrailPdfUrl = url;
              if ((acceptData != null ? acceptData.signatureMethod : void 0) === "saved") {
                acceptTelemetry.track("Used Stored Signature", {});
              }
              if (hasNoPrefillSignature && (acceptData != null ? acceptData.signatureMethod : void 0)) {
                acceptTelemetry.track("Saved Signature", {});
              }
              return changeViewState("sent");
            })
            ["catch"](function (err) {
              if (event != null) {
                event.preventDefault();
              }
              changeViewState("open");
              return $q.reject(err);
            });
        };
      })(this);
      if (settings.disclaimer != null) {
        disclaimer = tokenRenderer(settings.disclaimer.tokens);
      } else {
        if (settings.disclaimer == null) {
          settings.disclaimer = {
            tokens: [
              paragraph.createToken(),
              text.createToken(
                "I agree that my electronic signature is as valid and legally binding as a handwritten signature.",
              ),
            ],
          };
        }
        disclaimer = tokenRenderer(settings.disclaimer.tokens);
      }
      getUnbuiltSteps = function (accepters, settings) {
        var ref1, steps;
        steps = [
          {
            name: "accept",
            additionalParams: {
              isPreviewMode: isPreviewMode,
            },
          },
        ];
        if (settings.esignEnabled) {
          steps.push({
            name: "esign",
            additionalParams: {
              isPreviewMode: isPreviewMode,
            },
          });
        }
        if (settings.customForm != null) {
          steps.push({
            name: "customForm",
            additionalParams: {
              customForm: settings.customForm || {},
            },
          });
        }
        if (
          !isPrintMode &&
          isStripeIntegrationEnabled &&
          ((ref1 = settings.payNow) != null ? ref1.enabled : void 0) &&
          accepters.number === 1
        ) {
          steps.push({
            name: "payNow",
            additionalParams: {
              payNowSettings: settings.payNow || {},
              isGroupAccept: settings.accepters != null && settings.accepters.number > 1,
            },
          });
        }
        return steps;
      };
      if (accepters.number > 1) {
        acceptModule = require("./GroupAccept/GroupAccept");
      } else {
        if (
          accepters.enablePrefilledNames &&
          ((ref1 = accepters.prefilledNames[0]) != null ? ref1.length : void 0) > 0
        ) {
          acceptData.name = accepters.prefilledNames[0];
        }
        acceptModule = require("./SingleAccept/SingleAccept")["default"];
      }
      acceptForm = make(acceptModule, {
        acceptData: acceptData,
        acceptButton: settings.button,
        attemptAccept: attemptAccept,
        disclaimer: disclaimer,
        unbuiltSteps: getUnbuiltSteps(accepters, settings),
        options: {
          canGoBack: false,
        },
      });
      // Legacy Angular Accept Flow
      this.ui = createUi(require("./AcceptFlow.html"), {
        viewState: "open",
        acceptForm: acceptForm,
        sending: make(require("./Sending/Sending")["default"]),
        sent: make(require("./Sent/Sent")["default"], {
          acceptData: acceptData,
        }),
        $onElementRendered: (function (_this) {
          // don't scroll if we've unfurled the accept flow for printing
          if (isPrintMode) {
            return;
          }
          return function (elem) {
            return $timeout(function () {
              return scrollToTop();
            }, 220);
          };
        })(this),
      });
    }

    return AcceptFlow;
  })();
}.call(this));
